import * as React from "react";
import SlidingSignIn from "../../SignIn/views/Sliding";

function LandingPage() {
  return <SlidingSignIn></SlidingSignIn>
}

export default LandingPage;
